<template>
    <div class="content">
        <transition name="component-fade" mode="out-in" >
            <div v-show="detail">
                <a-divider orientation="left">逆变器列表</a-divider>
                <div class="menu">
                    <div class="item" :class="type === 0 ? 'active': ''" @click="changeType(0)">
                        <div>{{num.total}}</div>
                        <div>总数</div>
                    </div>
                    <div class="item" :class="type === -1 ? 'active': ''" @click="changeType(-1)">
                        <div>{{num.yx}}</div>
                        <div><i class="fa fa-circle text-info"></i> 运行</div>
                    </div>
                    <div class="item" :class="type === 32768 ? 'active': ''" @click="changeType(32768)">
                        <div>{{num.tj}}</div>
                        <div><i class="fa fa-circle text-danger"></i> 停机</div>
                    </div>
                    <div class="item" :class="type === 4864 ? 'active': ''" @click="changeType(4864)">
                        <div>{{num.ajgj}}</div>
                        <div><i class="fa fa-circle text-danger"></i> 按键关机</div>
                    </div>
                    <div class="item" :class="type === 5376 ? 'active': ''" @click="changeType(5376)">
                        <div>{{num.jjtj}}</div>
                        <div><i class="fa fa-circle text-danger"></i> 紧急停机</div>
                    </div>
                    <div class="item" :class="type === 5120 ? 'active': ''" @click="changeType(5120)">
                        <div>{{num.dj}}</div>
                        <div><i class="fa fa-circle text-muted"></i> 待机</div>
                    </div>
                    <div class="item" :class="type === 4608 ? 'active': ''" @click="changeType(4608)">
                        <div>{{num.csdj}}</div>
                        <div><i class="fa fa-circle text-muted"></i> 初始待机</div>
                    </div>
                    <div class="item" :class="type === 5632 ? 'active': ''" @click="changeType(5632)">
                        <div>{{num.qdz}}</div>
                        <div><i class="fa fa-circle text-warning"></i> 启动中</div>
                    </div>
                    <div class="item" :class="type === 37120 ? 'active': ''" @click="changeType(37120)">
                        <div>{{num.gjyx}}</div>
                        <div><i class="fa fa-circle text-warning"></i> 告警运行</div>
                    </div>
                    <div class="item" :class="type === 33024 ? 'active': ''" @click="changeType(33024)">
                        <div>{{num.jpyx}}</div>
                        <div><i class="fa fa-circle text-warning"></i> 降频运行</div>
                    </div>
                    <div class="item" :class="type === 33280 ? 'active': ''" @click="changeType(33280)">
                        <div>{{num.duyx}}</div>
                        <div><i class="fa fa-circle text-info"></i> 调度运行</div>
                    </div>
                    <div class="item" :class="type === 21760 ? 'active': ''" @click="changeType(21760)">
                        <div>{{num.gzyx}}</div>
                        <div><i class="fa fa-circle text-danger"></i> 故障运行</div>
                    </div>
                    <div class="item" :class="type === 9472 ? 'active': ''" @click="changeType(9472)">
                        <div>{{num.txgz}}</div>
                        <div><i class="fa fa-circle text-danger"></i> 通讯故障</div>
                    </div>

                </div>
                <inverter-table ref="inverterTable" @selectInverterDetail="clickInverter"></inverter-table>
            </div>

        </transition>
        <transition name="component-fade" mode="out-in" >
            <div v-show="!detail">
                <inverter-detail ref="inverterDetail" @backTable="backTable"></inverter-detail>
            </div>
        </transition>
    </div>
</template>

<script>
    import Bus from "@/utils/bus";
    import inverterTable from "./components/inverterTable";
    import inverterDetail from "./components/inverterDetail";
    export default {
        name: "inverterTableList",
        components:{
            inverterTable,
            inverterDetail
        },
        data(){
            return {
                detail: true,
                type: 0,
                groupId: this.$Utils.getUserStorage().groupId,
                num:{
                    total: 0,
                    yx: 0,
                    tj: 0,
                    ajgj: 0,
                    jjtj: 0,
                    dj: 0,
                    csdj: 0,
                    qdz: 0,
                    gjyx: 0,
                    jpyx: 0,
                    duyx: 0,
                    gzyx: 0,
                    txgz: 0,
                }
            }
        },
        mounted(){
            this.loadStatus();
            Bus.$on("inverterTableList", () => {
                this.backTable(true)
            });
        },
        methods:{
            changeType(type){
                this.type = type;
                this.loadTable();
            },
            async loadStatus(){
                let result = await this.$http.get(this.$baseURL.deviceRunStatus({groupId: this.groupId}))
                console.log(result)
                this.num.total = 0;
                this.num.yx = 0;
                this.num.tj = 0;
                this.num.ajgj = 0;
                this.num.jjtj = 0;
                this.num.dj = 0;
                this.num.csdj = 0;
                this.num.qdz = 0;
                this.num.gjyx = 0;
                this.num.jpyx = 0;
                this.num.duyx = 0;
                this.num.gzyx = 0;
                this.num.txgz = 0;
                result.forEach(item => {
                    let type = item.deviceRunStatusName;
                    if(type === '运行'){
                        this.num.yx = item.deviceRunStatusCount;
                    } else if (type === '停机'){
                        this.num.tj = item.deviceRunStatusCount;
                    } else if (type === '按键关机'){
                        this.num.ajgj = item.deviceRunStatusCount;
                    } else if (type === '紧急停机'){
                        this.num.jjtj = item.deviceRunStatusCount;
                    } else if (type === '待机'){
                        this.num.dj = item.deviceRunStatusCount;
                    } else if (type === '初始待机'){
                        this.num.csdj = item.deviceRunStatusCount;
                    } else if (type === '启动中'){
                        this.num.qdz = item.deviceRunStatusCount;
                    } else if (type === '告警运行'){
                        this.num.gjyx = item.deviceRunStatusCount;
                    } else if (type === '降频运行'){
                        this.num.jpyx = item.deviceRunStatusCount;
                    } else if (type === '调度运行'){
                        this.num.duyx = item.deviceRunStatusCount;
                    } else if (type === '故障运行'){
                        this.num.gzyx = item.deviceRunStatusCount;
                    } else if (type === '通讯故障'){
                        this.num.txgz = item.deviceRunStatusCount;
                    }
                    this.num.total += item.deviceRunStatusCount;
                });
            },
            loadTable(){
                console.log("thistype = ",this.type)
                this.$refs.inverterTable.loadTable(this.type);
            },
            clickInverter(obj){
                console.log('inverter detail ', obj)
                this.detail = !this.detail;
                this.$refs.inverterDetail.initInverter(obj);
            },
            backTable(flag){
                this.detail = flag;
            }
        }
    }
</script>

<style lang="less" scoped>
    .content {
        height: 100%;
        padding: 10px;
        .menu {
            display: flex;
            margin-bottom: 10px;
            .item {
                width: calc(100% / 13);
                text-align: center;
                padding: 10px 0;
                border: 1px solid #e0e0e0;
                border-right: 0;
                font-size: 16px;
                div{
                    padding: 3px;
                    &:first-child{
                        font-size: 18px;
                        font-weight: bold;
                    }
                }
                &:last-child{
                    border-right: 1px solid #e0e0e0;
                }
                &:hover{
                    cursor: pointer;
                    background: #1ab394;
                    color: #fff;
                }
                &.active {
                    background: #1ab394;
                    color: #fff;
                }
            }
        }
    }

    .component-fade-enter-active, .component-fade-leave-active {
        transition: opacity .5s ease;
    }
    .component-fade-enter, .component-fade-leave-to
        /* .component-fade-leave-active for below version 2.1.8 */ {
        opacity: 0;
    }

</style>
